import { z } from 'zod'
import { oc } from '@orpc/contract'
import { splitPlanSchema } from '../../model/incoming-fax/split-plan.schema'

// Split filing (PD-1988): files a multi-patient fax as one document per patient — each
// group's pages as their own PDF on that patient's chart (and, for labs, as a lab result).
// The original fax stays in the inbox. Sending the same plan again finishes an interrupted
// split.
export const triageIncomingFaxSplit = oc
  .route({ method: 'POST', path: '/v2/incoming-faxes/{id}/triage-split' })
  .input(splitPlanSchema.extend({ id: z.string() }))
  .output(
    z.object({
      documents: z.array(
        z.object({
          documentReferenceId: z.string(),
          patientId: z.string(),
          diagnosticReportId: z.string().optional(),
        }),
      ),
    }),
  )
